import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export default function OwnerDashboard() {
  const [data] = useState({
    acresDone: 10800, totalAcres: 25000, efficiency: 89.4, uptime: 93.1,
    todayAcres: 1450, avgAcresDay: 1800, daysActive: 8, crewSize: 12,
    totalCost: 142500, costPerAcre: 13.19, fuelCost: 38200, labourCost: 52100,
    openTickets: 2, criticalTickets: 0, activeMoves: 1,
    topEquip: [
      { name: 'NH T9.645 #1', acres: 3200, status: 'running' },
      { name: 'NH T9.645 #2', acres: 2800, status: 'running' },
      { name: 'NH CR10.90 #1', acres: 2400, status: 'running' },
      { name: 'NH T8.435', acres: 2400, status: 'running' },
    ],
    sites: [
      { name: 'Kamsack Main', acres: 7200, target: 15000, crew: 8 },
      { name: 'North Range', acres: 3600, target: 10000, crew: 4 },
    ],
  });
  useEffect(function() { /* Future: fetch from supabase */ }, []);

  var pct = ((data.acresDone / data.totalAcres) * 100).toFixed(1);
  var daysLeft = Math.ceil((data.totalAcres - data.acresDone) / data.avgAcresDay);
  var fmt = function(n) { return '$'+n.toLocaleString('en-CA',{minimumFractionDigits:0,maximumFractionDigits:0}); };

  return (
    <div className="page-container">
      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0, color: 'var(--text)' }}>Owner Dashboard</h1>
        <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Geerts Farms Ltd. &mdash; 2025 Spring Seeding Overview</p>
      </div>

      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
        {[
          { l: 'Acres Done', v: data.acresDone.toLocaleString(), sub: 'of '+data.totalAcres.toLocaleString(), c: 'var(--primary)' },
          { l: 'Season Progress', v: pct+'%', sub: daysLeft+' days remaining', c: 'var(--primary)' },
          { l: 'Efficiency', v: data.efficiency+'%', sub: 'Target: 90%', c: data.efficiency >= 85 ? 'var(--primary)' : '#f59e0b' },
          { l: 'Equipment Uptime', v: data.uptime+'%', sub: data.openTickets+' open tickets', c: data.uptime >= 90 ? '#22c55e' : '#f59e0b' },
        ].map(function(s) {
          return (
            <div key={s.l} className="stat-card" style={{ background: 'var(--surface)', borderRadius: '16px', padding: '1.5rem', textAlign: 'center' }}>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{s.l}</div>
              <div style={{ color: s.c, fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.1 }}>{s.v}</div>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: '0.25rem' }}>{s.sub}</div>
            </div>
          );
        })}
      </div>

      <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem' }}>
        <h3 style={{ color: 'var(--text)', marginTop: 0, marginBottom: '0.75rem' }}>Season Progress</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
          <span style={{ color: 'var(--text)' }}>{data.acresDone.toLocaleString()} / {data.totalAcres.toLocaleString()} acres</span>
          <span style={{ color: 'var(--primary)', fontWeight: 700 }}>{pct}%</span>
        </div>
        <div style={{ background: 'var(--bg)', borderRadius: '12px', height: '32px', overflow: 'hidden' }}>
          <div style={{ height: '100%', width: pct+'%', background: 'linear-gradient(90deg, var(--primary), var(--secondary))', borderRadius: '12px', transition: 'width 0.5s' }} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Quick Numbers</h3>
          {[
            { l: 'Today Acres', v: data.todayAcres.toLocaleString()+' ac', c: 'var(--primary)' },
            { l: 'Avg Acres/Day', v: data.avgAcresDay.toLocaleString()+' ac', c: 'var(--primary)' },
            { l: 'Days Active', v: data.daysActive, c: 'var(--text)' },
            { l: 'Crew Size', v: data.crewSize+' people', c: 'var(--text)' },
            { l: 'Total Spend', v: fmt(data.totalCost), c: '#f59e0b' },
            { l: 'Cost/Acre', v: '$'+data.costPerAcre.toFixed(2), c: '#3b82f6' },
            { l: 'Fuel Cost', v: fmt(data.fuelCost), c: '#f59e0b' },
            { l: 'Labour Cost', v: fmt(data.labourCost), c: '#f59e0b' },
          ].map(function(item) {
            return (
              <div key={item.l} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.65rem 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--text-secondary)' }}>{item.l}</span>
                <span style={{ color: item.c, fontWeight: 700 }}>{item.v}</span>
              </div>
            );
          })}
        </div>

        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Sites</h3>
          {data.sites.map(function(site) {
            var sitePct = ((site.acres / site.target) * 100).toFixed(0);
            return (
              <div key={site.name} style={{ marginBottom: '1.25rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.35rem' }}>
                  <span style={{ color: 'var(--text)', fontWeight: 600 }}>{site.name}</span>
                  <span style={{ color: 'var(--primary)', fontWeight: 600 }}>{sitePct}%</span>
                </div>
                <div style={{ background: 'var(--bg)', borderRadius: '6px', height: '10px', overflow: 'hidden', marginBottom: '0.35rem' }}>
                  <div style={{ height: '100%', width: sitePct+'%', background: 'var(--primary)', borderRadius: '6px' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                  <span>{site.acres.toLocaleString()} / {site.target.toLocaleString()} ac</span>
                  <span>{site.crew} crew</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
        <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Equipment Status</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
          {data.topEquip.map(function(eq) {
            var isDown = eq.status === 'down';
            return (
              <div key={eq.name} style={{ background: 'var(--bg)', borderRadius: '10px', padding: '1rem', borderLeft: isDown ? '4px solid #ef4444' : '4px solid var(--primary)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                  <span style={{ color: 'var(--text)', fontWeight: 600 }}>{eq.name}</span>
                  <span style={{ background: isDown ? '#ef444422' : '#22c55e22', color: isDown ? '#ef4444' : '#22c55e', padding: '2px 8px', borderRadius: '8px', fontSize: '0.75rem', fontWeight: 600 }}>{eq.status}</span>
                </div>
                <div style={{ color: 'var(--primary)', fontSize: '1.5rem', fontWeight: 700 }}>{eq.acres.toLocaleString()} <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', fontWeight: 400 }}>acres</span></div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ marginTop: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
        {[
          { l: 'Open Maintenance', v: data.openTickets, sub: data.criticalTickets+' critical', c: '#f59e0b', link: '/maintenance' },
          { l: 'Active Moves', v: data.activeMoves, sub: 'FleetsIQ linked', c: '#3b82f6', link: '/logistics' },
          { l: 'Crew Active', v: data.crewSize, sub: '2 sites', c: 'var(--primary)', link: '/payroll' },
        ].map(function(card) {
          return (
            <div key={card.l} className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.25rem', textAlign: 'center', cursor: 'pointer' }}>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.25rem' }}>{card.l}</div>
              <div style={{ color: card.c, fontSize: '2rem', fontWeight: 700 }}>{card.v}</div>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>{card.sub}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
